import s6 from './succulents/Cactus/6.jpg';
import s7 from './succulents/Cactus/7.jpg';
import s8 from './succulents/Cactus/8.jpg';
import s9 from './succulents/Cactus/9.jpg';
import s10 from './succulents/Cactus/10.jpg';
import s11 from './succulents/Cactus/11.jpg';
import s12 from './succulents/Cactus/12.jpg';
import s13 from './succulents/Cactus/13.jpg';
import s14 from './succulents/Cactus/14.jpg';
import s15 from './succulents/Cactus/15.jpg';
import s16 from './succulents/Cactus/16.jpg';

let Cactus = [
    {
        key: 6,
        name: 'GOLDEN BARREL CACTUS',
        img: s6,
        price: 5,
        description: "Primarily suited for growing in garden rockery settings, desert type landscapes, patios and botanical gardens.",
    },

    {
        key: 7,
        name: "MINI RAT'S TAIL CACTUS",
        img: s7,
        price: 5,
        description: "It is distinctive for its long, trailing stems, fine spines that grow to 6 feet in length at maturity.",
        descriptionLong: "Native to Mexico, it is distinctive for its long, trailing stems, fine spines that grow to 6 feet in length at maturity. The overall color of the plant is green when young but the stems age to almost beige color.",
    },

    {
        key: 8,
        name: "BISHOP'S CAP CACTUS",
        img: s8,
        price: 5,
        description: "A rare cactus that has no spikes but white hairy scales that give it a characteristic chalk-white or silvery-grey appearance.",
        descriptionLong: "A rare cactus that has no spikes but white hairy scales that give it a characteristic chalk-white or silvery-grey appearance. It often has 5 ribs, but can grow up to 8 ribs with age.",
    },

    {
        key: 9,
        name: 'GOLDEN BALL CACTUS',
        img: s9,
        price: 7,
        description: "Also called Golden Ball, Lemon Ball, or Yellow Tower. It's covered with harmless thin yellow spines.",
    },

    {
        key: 10,
        name: 'Ball Cactus',
        img: s10,
        price: 6,
        description: "Frequently produce flowers in beautiful shades of yellow, red, orange, or pink.",
        descriptionLong: "Are moderate growers, adding about 4 inches to their height each year. Older plants will frequently produce flowers in beautiful shades of yellow, red, orange, or pink, and all varietals feature ridges of spikes that start white and grow to a yellow-brown with age.",
    },

    {
        key: 11,
        name: 'HAIRY ROGER CACTUS',
        img: s11,
        price: 5,
        description: 'Is indigenous to Mexico, a bushy succulent shrub with light green, egg-shaped, fleshy pads.',
        descriptionLong: 'Is indigenous to Mexico, a bushy succulent shrub with light green, egg-shaped, fleshy pads. The spines are quite short, and are often white, tan brown or yellow.',
    },

    {
        key: 12,
        name: 'DANCING BONES CACTUS',
        img: s12,
        price: 8,
        description: "A slender, erect, arching or somewhat pendent, bushy, cactus, up to 2 feet (60 cm) tall.",
    },

    {
        key: 13,
        name: 'CINNAMON CACTUS',
        img: s13,
        price: 12,
        description: 'The pads are covered with very small brownish-cinnamon colored spines or glochids. Very compact and self branching.',
        descriptionLong: 'A miniature prickly pear version also known as Cinnamon Cactus which only grows to approx. 8" to 10" in height. The pads are covered with very small brownish-cinnamon colored spines or glochids. Very compact and self branching a good variety for growing as a houseplant or placement outdoors in frost-free locations in the rock garden.',
    },

    {
        key: 14,
        name: 'MOON CACTUS',
        img: s14,
        price: 12,
        description: 'These cacti are not toxic. It can be placed near pets and children without any worries.',
    },

    {
        key: 15,
        name: 'CRESTED BLUE CANDLE',
        img: s15,
        price: 10,
        description: "It can grow quite large, spreading out over a thick columnar trunk, stems cresting and creating waves as it grows.",
    },

    {
        key: 16,
        name: 'SAGUARO CACTUS',
        img: s16,
        price: 12,
        description: "Composed of a tall, thick, fluted, columnar stem, often with several large branches curving upward.",
        descriptionLong: "Composed of a tall, thick, fluted, columnar stem, 18 to 24 inches in diameter, often with several large branches (arms) curving upward in the most distinctive conformation of all Southwestern cacti. The skin is smooth and waxy, and the trunk and stems have stout, two inch spines clustered on their ribs.",
    },
]

export default Cactus;